<template>
  <div>
    <div class="text-h6">
      Prize draws
    </div>
    <p>
      Are you running a business prize draw at your event?
    </p>

    <div class="d-flex justify-start">
      <v-btn
        width="100"
        :color="currentEvent.hasPrizeDraw ? 'primary' : 'grey'"
        :outlined="currentEvent.hasPrizeDraw ? false : true"
        depressed
        class="text-body-1 mr-3"
        @click="currentEvent.hasPrizeDraw = true"
        >Yes</v-btn
      >
      <v-btn
        width="100"
        :color="currentEvent.hasPrizeDraw ? 'grey' : 'primary'"
        :outlined="currentEvent.hasPrizeDraw"
        depressed
        class="text-body-1"
        @click="currentEvent.hasPrizeDraw = false"
        >No</v-btn
      >
    </div>
    <v-row v-if="currentEvent.hasPrizeDraw">
      <v-col cols="12">
        <v-chip label color="rgba( 241, 95, 49, 0.24)" small light>
          <v-icon left color="primary" small> mdi-information-outline </v-icon
          >If you have not finalised your prizes, you can come back to this
          later.</v-chip
        >
      </v-col>
      <v-col cols="12">
        <v-divider> </v-divider>
      </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Minimum card entries
        </div>
        <div class="text-body">
          Is there a minimum card entries you’ll need in order to conduct the
          card prize draws?
          <span class="grey--text"> (optional) </span>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          outlined
          dense
          prefix="I need at least"
          v-model="currentEvent.minimumCardEntriesForPrizeDraw"
          suffix="card entries to conduct the prize draw."
        />
      </v-col>
      <v-col cols="12"> <v-divider> </v-divider> </v-col>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Available prizes
        </div>
      </v-col>

      <v-col cols="12" class="d-flex justify-start" width="100%">
        <v-row>
          <template v-if="currentEvent.prizes.length != 0">
            <v-col
              cols="12"
              md="6"
              v-for="prize in currentEvent.prizes"
              :key="prize.id"
            >
              <v-sheet
                outlined
                color="grey"
                class="rounded-lg mr-8"
                max-width="400"
                width="400"
              >
                <v-card height="100%">
                  <v-row no-gutters>
                    <v-col md="3" class="d-flex  align-center">
                      <v-img :src="prize.image" height="60" contain />
                    </v-col>
                    <v-col md="1" class="text-center">
                      <v-divider vertical> </v-divider>
                    </v-col>
                    <v-col md="4" class="mr-1">
                      <div class="text-caption grey--text">Prize title</div>
                      <div class="text-body-2 ">{{ prize.title }}</div>

                      <v-spacer> </v-spacer>
                      <div class="text-caption grey--text mt-4">
                        What is the prize?
                      </div>
                      <div class="text-body-2 ">{{ prize.description }}</div>
                      <v-spacer> </v-spacer>
                      <div class="text-caption grey--text mt-4">
                        No. of winners
                      </div>
                      <div class="text-body-2 ">{{ prize.noOfWinners }}</div>
                    </v-col>
                    <v-col cols="4" md="3">
                      <div class="d-flex justify-space-between">
                        <v-btn
                          text
                          small
                          color="primary"
                          class="px-0"
                          @click="handleEdit(prize)"
                        >
                          Edit
                        </v-btn>
                        <v-btn
                          text
                          small
                          color="primary"
                          class="px-0"
                          @click="handleRemove(prize)"
                        >
                          Remove
                        </v-btn>
                        <v-spacer> </v-spacer>
                      </div>
                      <div class="text-caption grey--text mt-7">
                        Sponsored by:
                      </div>
                      <img :src="prize.sponsorsLogo" height="30" />
                    </v-col>
                  </v-row>
                </v-card>
              </v-sheet>
            </v-col>
          </template>
          <v-col cols="12" md="6">
            <v-sheet
              outlined
              color="grey"
              class="rounded-lg"
              max-width="400"
              width="400"
            >
              <v-card
                height="155"
                class="d-flex justify-center align-center"
                @click="addPrize"
              >
                <v-btn text color="grey" height="155" width="100%"
                  >+ Add a prize</v-btn
                >
              </v-card>
            </v-sheet>
          </v-col>
        </v-row>

        <AddEditPrizeDialog
          v-if="addEditPrizeDialog"
          :showDialog="addEditPrizeDialog"
          @closeDialog="closePrizeDialog"
          :title="addEditPrizeTitle"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AddEditPrizeDialog from "@/components/AddEditPrizeDialog";
import Prize from "@/models/Prize";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    AddEditPrizeDialog,
  },
  computed: {
    ...mapGetters(["currentEvent", "currentPrize"]),
  },

  data() {
    return {
      isPrizeDraw: false,
      addEditPrizeDialog: false,
      availablePrizes: [
        {
          id: "1",
          title: "Grand Prize",
          description: "MacBook Air 13-inch",
          noOfWinners: "1",
          sponsoredBy: "../assets/sposnors-logo.png",
          image: "../assets/prize-image.png",
        },
      ],
      addEditPrizeTitle: "",
    };
  },
  methods: {
    ...mapActions(["setCurrentPrize"]),
    async addPrize() {
      this.addEditPrizeTitle = "Add Prize";
      let prize = new Prize({});
      console.log("prize is", prize);
      await this.setCurrentPrize(prize);
      this.addEditPrizeDialog = true;
    },
    closePrizeDialog() {
      this.addEditPrizeDialog = false;
    },
    handleEdit(prize) {
      this.addEditPrizeTitle = "Edit Prize";
      this.setCurrentPrize(prize);
      this.addEditPrizeDialog = true;
    },
    handleRemove(prize) {
      let index = this.currentEvent.prizes.indexOf(prize);
      this.currentEvent.prizes.splice(index, 1);
    },
  },
};
</script>

<style></style>
